import { render, staticRenderFns } from "./ProductManagementCd.vue?vue&type=template&id=7b56ed76&scoped=true&"
import script from "./ProductManagementCd.vue?vue&type=script&lang=ts&"
export * from "./ProductManagementCd.vue?vue&type=script&lang=ts&"
import style0 from "./ProductManagementCd.vue?vue&type=style&index=0&id=7b56ed76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56ed76",
  null
  
)

export default component.exports